import { render } from "./VsCheckbox.vue?vue&type=template&id=1a201220"
import script from "./VsCheckbox.vue?vue&type=script&lang=js"
export * from "./VsCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__